import assessChoices from "./assessChoices";
import assessInput from "./assessInput";

export default {
    assessChoices: assessChoices,
    assessInput: assessInput
}